import { Navigate, useRoutes } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';

// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import DashboardAppPage from './pages/DashboardAppPage';
import UsersControl from './ASK/Master/UsersControl';
import ClientReviews from './ASK/Master/ClientReviews';
import Blogs from './ASK/Master/Blogs';
import ProductMaster from './ASK/Master/ProductMaster';
import FAQMaster from './ASK/Master/FAQMaster';
import WebEnquiriesReports from './MisReports/WebEnquiriesReports';
import OurPartners from './ASK/Master/OurPartners';
import CaseStudy from './ASK/Master/CaseStudy';
import SMTPProfileMaster from './ASK/Master/SMTPProfileMaster';

// ----------------------------------------------------------------------

const isAuthenticated = () => {
  const loginStatus = localStorage.getItem('LoginStatus');
  return loginStatus === 'Y';
};

// ProtectedRoute HOC
const ProtectedRoute = ({ element }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return element;
};

// for  techvel dashboard
export default function Router() {
  const routes = useRoutes([
    {
      path: '/dashboard',
      element: (
        <>
          <Helmet>
            <title>ASK TECHNOLOGY | Dashboard</title>
          </Helmet>
          <DashboardLayout />
        </>
      ),
      children: [
        { element: <Navigate to="/dashboard/users_access_control" />, index: true },
        { path: 'app', element: <DashboardAppPage /> },
        { path: 'ask/client_reviews', element: <ClientReviews /> },
        { path: 'ask/blogs', element: <Blogs /> },
        { path: 'ask/product_master', element: <ProductMaster /> },
        { path: 'ask/faq_master', element: <FAQMaster /> },
        { path: 'ask/case_study', element: <CaseStudy /> },
        { path: 'ask/smtp_profile_master', element: <SMTPProfileMaster /> },
        { path: 'ask/web_enquires', element: <WebEnquiriesReports /> },
        { path: 'users_access_control', element: <UsersControl /> },
        { path: 'our_partners', element: <OurPartners /> },
      ].map((route) => ({ ...route, element: <ProtectedRoute element={route.element} /> })),
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="login" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ].map((route) => ({ ...route, element: <ProtectedRoute element={route.element} /> })),
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
    {
      path: 'login',
      element: (
        <>
          <Helmet>
            <title>ASK TECHNOLOGY | Login</title>
          </Helmet>
          <LoginPage />
        </>
      ),
    },
  ]);

  return routes;
}
